import React, { useState } from "react";
import Divider from "../components/Divider";
import { Button } from "@mui/material";

function ShareChat({ onClose }) {
  const [link, setLink] = useState("");
  const [showLink, setShowLink] = useState(false);
  const [copy, setCopy] = useState(false);

  const handleClick = () => {
    const currentUrl = window.location.href;
    setLink(currentUrl);
    setShowLink(true);
  };
  const handleCopy = () => {
    navigator.clipboard.writeText(link);
    setCopy(true);
  };

  return (
    <div className="fixed z-10 top-0 bottom-0 left-0 right-0 bg-slate-400 bg-opacity-40 flex justify-center items-center">
      <div className="bg-slate-100 dark:bg-slate-900 p-4 m-6 rounded w-full max-w-sm">
        <h2 className="font-semibold">Public Link</h2>
        <form className="grid gap-3 mt-3" onSubmit={""}>
          <div className="flex flex-col gap-1">
            <label htmlFor="name">Share Link</label>
            <p
              placeholder="https://gemini.com/share/..."
              className="w-full py-1 px-2 dark:bg-black focus:outline-primary dark:focus-within:bg-black bg-slate-200 border-0.5"
            >
              {link}
            </p>
          </div>
          <div>
            {!showLink ? (
              <Button sx={{ marginLeft: "14rem" }} onClick={handleClick}>
                Update Link
              </Button>
            ) : (
              <Button sx={{ marginLeft: "14rem" }} onClick={handleCopy}>
                {!copy ? "Copy Link" : "Copied"}
              </Button>
            )}
          </div>
          <Divider />
          <div
            className="flex
             gap-2 w-fit ml-auto mt-3"
          >
            <Button
              onClick={onClose}
              className="border-primary text-primary border px-3 py-1 rounded hover:bg-stone-500 hover:text-white"
            >
              ok
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default React.memo(ShareChat);
